import * as React from "react";
import { MenuItem } from "./menu-item";
import { ScreenLocalState, PivotLocalState } from "../lib/navigation-model";

export interface AppBarContext {
    title: string;
    barButtonItems: MenuItem[];
    onBack?: () => void;
}

export interface AppUtilities {
    overlayAppBar: (context: AppBarContext, token?: any) => any;
    removeAppBarOverlay: (token: any) => boolean;
    getScreenLocalState: () => Readonly<ScreenLocalState>;
    updateScreenLocalState: (updates: Readonly<Partial<ScreenLocalState>>) => Readonly<ScreenLocalState>;
    getPivotLocalState: () => Readonly<PivotLocalState>;
    pivotLocalStateForIndex: (index: number) => Readonly<PivotLocalState>;
    updatePivotLocalState: (updates: Readonly<Partial<PivotLocalState>>) => Readonly<PivotLocalState>;
}

const AppUtilityContext = React.createContext<AppUtilities>({
    overlayAppBar: () => 0,
    removeAppBarOverlay: () => false,
    getScreenLocalState: () => {
        return {};
    },
    updateScreenLocalState: () => {
        return {};
    },
    getPivotLocalState: () => {
        return {};
    },
    pivotLocalStateForIndex: (_: number) => {
        return {};
    },
    updatePivotLocalState: () => {
        return {};
    },
});

export const AppUtilitiesProvider = AppUtilityContext.Provider;
export const AppUtilitiesConsumer = AppUtilityContext.Consumer;
